module.exports = __webpack_public_path__ + "static/media/labtrino.c95d9511.jpg";